module.exports = __webpack_public_path__ + "img/logo@col.d54fd12e.png";